// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { toValue } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CrmRelationsSpecialeContactpersonenDto } from '../model/crmRelationsSpecialeContactpersonenDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieAanmaken</li></ul>
 * @summary Maak de speciale contactpersonen aan
 */
export const relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  crmRelationsSpecialeContactpersonenDto?: MaybeRefOrGetter<CrmRelationsSpecialeContactpersonenDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);
  crmRelationsSpecialeContactpersonenDto = toValue(crmRelationsSpecialeContactpersonenDto);

  return customInstance<void>(
    {
      url: `/api/v1/relaties/${relatienummer}/specialeContactpersonen`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsSpecialeContactpersonenDto,
      signal,
    },
    options,
  );
};

export const getRelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan>>,
    TError,
    RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan>>,
  TError,
  RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationVariables,
  TContext
> => {
  const mutationKey = ['relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan>>,
    RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationVariables
  > = (props) => {
    const { relatienummer, data } = props ?? {};

    return relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan(
      relatienummer,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan>>
  >;
export type RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationBody =
  | CrmRelationsSpecialeContactpersonenDto
  | undefined;
export type RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationError =
  ErrorType<void>;
export type RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationVariables = {
  relatienummer: number | undefined | null;
  data?: CrmRelationsSpecialeContactpersonenDto;
};

/**
 * @summary Maak de speciale contactpersonen aan
 */
export const useRelatieSpecialeContactpersonenMaakSpecialeContactpersonenAan = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan>>,
      TError,
      RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieSpecialeContactpersonenMaakSpecialeContactpersonenAan>>,
  TError,
  RelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationVariables,
  TContext
> => {
  return useMutation(
    getRelatieSpecialeContactpersonenMaakSpecialeContactpersonenAanMutationOptions(options),
    queryClient,
  );
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.RelatieBijwerken</li></ul>
 * @summary Werkt speciale contactpersonen bij
 */
export const relatieSpecialeContactpersonenWijzigSpecialeContactpersonen = (
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  crmRelationsSpecialeContactpersonenDto?: MaybeRefOrGetter<CrmRelationsSpecialeContactpersonenDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = toValue(relatienummer);
  crmRelationsSpecialeContactpersonenDto = toValue(crmRelationsSpecialeContactpersonenDto);

  return customInstance<void>(
    {
      url: `/api/v1/relaties/${relatienummer}/specialeContactpersonen`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmRelationsSpecialeContactpersonenDto,
      signal,
    },
    options,
  );
};

export const getRelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relatieSpecialeContactpersonenWijzigSpecialeContactpersonen>>,
    TError,
    RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relatieSpecialeContactpersonenWijzigSpecialeContactpersonen>>,
  TError,
  RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationVariables,
  TContext
> => {
  const mutationKey = ['relatieSpecialeContactpersonenWijzigSpecialeContactpersonen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relatieSpecialeContactpersonenWijzigSpecialeContactpersonen>>,
    RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationVariables
  > = (props) => {
    const { relatienummer, data } = props ?? {};

    return relatieSpecialeContactpersonenWijzigSpecialeContactpersonen(
      relatienummer,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationResult = NonNullable<
  Awaited<ReturnType<typeof relatieSpecialeContactpersonenWijzigSpecialeContactpersonen>>
>;
export type RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationBody =
  | CrmRelationsSpecialeContactpersonenDto
  | undefined;
export type RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationError =
  ErrorType<void>;
export type RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationVariables = {
  relatienummer: number | undefined | null;
  data?: CrmRelationsSpecialeContactpersonenDto;
};

/**
 * @summary Werkt speciale contactpersonen bij
 */
export const useRelatieSpecialeContactpersonenWijzigSpecialeContactpersonen = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relatieSpecialeContactpersonenWijzigSpecialeContactpersonen>>,
      TError,
      RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof relatieSpecialeContactpersonenWijzigSpecialeContactpersonen>>,
  TError,
  RelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationVariables,
  TContext
> => {
  return useMutation(
    getRelatieSpecialeContactpersonenWijzigSpecialeContactpersonenMutationOptions(options),
    queryClient,
  );
};
